/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AndoApiLogResponseDto = {
    /**
     * Unique log identifier (UUID)
     */
    id: string;
    /**
     * Log creation timestamp
     */
    createdAt: string;
    /**
     * Ando API service name (e.g. CustomerApi, PolicyApi)
     */
    andoService: string;
    /**
     * Ando operation name (best-effort semantic name)
     */
    operation: string;
    /**
     * Related client UUID (when known)
     */
    clientId?: string | null;
    /**
     * Entity type this Ando call relates to
     */
    entityType: AndoApiLogResponseDto.entityType;
    /**
     * Entity identifier (string for flexibility across tables)
     */
    entityId?: string | null;
    /**
     * Request payload sent to Ando (JSON)
     */
    requestPayload: Record<string, any>;
    /**
     * Response payload returned by Ando (JSON)
     */
    responsePayload?: Record<string, any> | null;
    /**
     * Error payload returned by Ando (JSON)
     */
    errorPayload?: Record<string, any> | null;
    /**
     * Error message (if the call failed)
     */
    errorMessage?: string | null;
    /**
     * Duration in milliseconds
     */
    durationMs?: number | null;
};
export namespace AndoApiLogResponseDto {
    /**
     * Entity type this Ando call relates to
     */
    export enum entityType {
        CLIENT = 'CLIENT',
        QUOTE = 'QUOTE',
        POLICY = 'POLICY',
        RENEWAL = 'RENEWAL',
        MTA = 'MTA',
        OTHER = 'OTHER',
    }
}

